"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Action_1 = require("./action/Action");
exports.Action = Action_1.Action;
const BaseAction_1 = require("./action/BaseAction");
exports.BaseAction = BaseAction_1.BaseAction;
const ButtonAction_1 = require("./action/ButtonAction");
exports.ButtonAction = ButtonAction_1.ButtonAction;
const CheckEditor_1 = require("./action/CheckEditor");
exports.CheckEditor = CheckEditor_1.CheckEditor;
const Editor_1 = require("./action/Editor");
exports.Editor = Editor_1.Editor;
const InlineInputEditor_1 = require("./action/InlineInputEditor");
exports.InlineInputEditor = InlineInputEditor_1.InlineInputEditor;
const InlineMenuEditor_1 = require("./action/InlineMenuEditor");
exports.InlineMenuEditor = InlineMenuEditor_1.InlineMenuEditor;
const SmallDialogInputEditor_1 = require("./action/SmallDialogInputEditor");
exports.SmallDialogInputEditor = SmallDialogInputEditor_1.SmallDialogInputEditor;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
class ImmutableCheckEditor extends CheckEditor_1.CheckEditor {
    get disabled() {
        return this._disabled;
    }
    get readOnly() {
        return this._readOnly;
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
class ImmutableInputEditor extends SmallDialogInputEditor_1.SmallDialogInputEditor {
    get disabled() {
        return this._disabled;
    }
    get readOnly() {
        return this._readOnly;
    }
}
exports.ACTIONS = {
    CHECK: new ImmutableCheckEditor(),
    INPUT: new ImmutableInputEditor(),
};
function of(columnAction) {
    if (!columnAction) {
        return undefined;
    }
    else if (typeof columnAction === "string") {
        const key = columnAction.toUpperCase();
        return exports.ACTIONS[key] || of(null);
    }
    else {
        return columnAction;
    }
}
exports.of = of;
